import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

import BestRideShareLawyersWrapper from "@components/layouts/bestridesharelawyersWrapper";

export default function BestPostageMetersHome(): ReactElement {
    return (
        <BestRideShareLawyersWrapper>
            <PrivacyPolicy
                category="Ride Share"
                domain="BestRideShareLawyers.com"
            />
        </BestRideShareLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
